<app-dialog-header title="Add Division" (closeClicked)="cancel()">
</app-dialog-header>

<form (ngSubmit)="submit()" [formGroup]="divisionForm">
  <mat-dialog-content class="fullscreen-dialog">
    <mat-form-field appearance="fill">
      <mat-label>Division Name*</mat-label>
      <input formControlName="name" matInput type="text" placeholder="Enter division name">
      @if (divisionForm.get('name')?.hasError('required')) {
      <mat-error>
        Division name is required
      </mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button color="primary" mat-raised-button type="submit" [disabled]="!divisionForm.valid">Save</button>
  </mat-dialog-actions>
</form>